import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "UnlinkOrganisationWarningModal"
}
const _hoisted_2 = { class: "UnlinkOrganisationWarningContentBlock" }
const _hoisted_3 = { class: "UnlinkOrganisationWarningTextBlock" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "UnlinkOrganisationWarningHeaderBlock" }, [
      _createElementVNode("h3", null, [
        _createElementVNode("i", { class: "lnr-info" }),
        _createElementVNode("span", null, "Unlink Organisation(s)")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode(" This unlinking change will affect ", -1 /* CACHED */)),
        _createElementVNode("strong", null, _toDisplayString(_ctx.entitiesAffectedByUnlinking.length), 1 /* TEXT */),
        _createTextVNode(" " + _toDisplayString(_ctx.entitiesAffectedByUnlinking.length === 1 ? 'entity' : 'entities') + ". If you choose to proceed, ", 1 /* TEXT */),
        _cache[3] || (_cache[3] = _createElementVNode("strong", null, "all attached entities", -1 /* CACHED */)),
        _cache[4] || (_cache[4] = _createTextVNode(" will be detached from this campaign and moved to Basic. ", -1 /* CACHED */))
      ]),
      _createElementVNode("button", {
        ref: "proceedButton",
        class: "DriverButton UnlinkOrganisationWarningButton",
        "data-style": "zoom-in",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.proceed && _ctx.proceed(...args))),
        disabled: !_ctx.isSaveEnabled
      }, " Detach entities & unlink ", 8 /* PROPS */, _hoisted_4),
      _createElementVNode("button", {
        class: "NavigatorButton UnlinkOrganisationWarningButton",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, " Cancel ")
    ])
  ], 512 /* NEED_PATCH */))
}